module.exports = __webpack_public_path__ + "img/CATEGORY ICON-24.35bb975f.png";